//#region src/components/Tree/TreeNodeHeader/TreeNodeHeader.module.css
var e = "_labelContainer_jbyue_1", t = "_tooltip_jbyue_11", n = "_title_jbyue_15", r = "_nodeContent_jbyue_21", i = "_expandButton_jbyue_28", a = "_buttonPlaceholder_jbyue_32", o = "_container_jbyue_37", s = "_heading_jbyue_44", c = {
	labelContainer: e,
	tooltip: t,
	title: n,
	nodeContent: r,
	expandButton: i,
	buttonPlaceholder: a,
	container: o,
	heading: s
};
//#endregion
export { a as buttonPlaceholder, o as container, c as default, i as expandButton, s as heading, e as labelContainer, r as nodeContent, n as title, t as tooltip };
